/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FONDOCARD} from "../../Constantes";
import {AccessTime, LocalOffer, StarRate, TaskOutlined} from "@mui/icons-material";
import IconoTexto from "./Componentes/IconoTexto";
import {useObtenerAncho} from "../../Modulo_Graficas/Hooks/useObtenerAncho";
import {useContext, useEffect, useRef, useState} from "react";
import Dona_Limpia from "../../Modulo_Graficas/Graficas/Dona_Limpia";
import {usuarioContext} from "../../App";
import {where} from "firebase/firestore";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {obtenerGanancias} from "../../CodigoCliente/Ganancias/obtenerGanancias";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {verificarMembresia} from "../../CodigoCliente/Funciones/verificarMembresia";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {obtenerTotalBonos} from "../../CodigoCliente/Bonos/obtenerTotalBonos";
import {obtenerGananciaBonos} from "../../CodigoCliente/Ganancias/obtenerGananciaBonos";
import {obtenerGananciaRendimientos} from "../../CodigoCliente/Ganancias/obtenerGananciaRendimientos";


const Tarjeta_Ganancias = () => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const refe = useRef()
    const {ancho} = useObtenerAncho({contenedor: refe})
    const [numContratos, setNumContratos] = useState(0)
    const [totalRendimientos, setTotalRendimientos] = useState(0)
    const [totalBonos, setTotalBonos] = useState(0)


    useEffect(() => {
        let w = [where('idUsuario', '==', cData.usuario.id)]
        contarWheres({coleccion: 'contratos', wheres: w}).then((dox) => {
            setNumContratos(dox.data)
        })

        obtenerGananciaBonos(cData.usuario.id).then((des) =>{

            obtenerGananciaRendimientos(cData.usuario.id).then((dox) =>{
                setTotalBonos(des)
                setTotalRendimientos(dox)
            })

        })


    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                ...FONDOCARD,
                p: 2,
                color: '#fff',
                minHeight: 200
            }}
        >

            <Grid container size={{xs: 7, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>Ganancias Producidas</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontSize: 24,
                            fontWeight: 600
                        }}>{`${formatoMonedaTabla(totalRendimientos + totalBonos, 2)} UDS`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <IconoTexto Icono={TaskOutlined} texto={`${numContratos} Contratos`}
                                    color={numContratos > 0 ? '#fff' : '#ffffff90'}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                        <IconoTexto Icono={StarRate}
                                    texto={`Membresía ${verificarMembresia(cData.usuario) ? 'Activa' : 'Inactiva'}`}
                                    color={verificarMembresia(cData.usuario) ? '#fff' : '#ffffff80'}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                        <IconoTexto Icono={LocalOffer} texto={'Bonos'} color={totalBonos > 0 ? '#fff' : '#ffffff80'}/>
                    </Grid>


                </Grid>
            </Grid>


            <Grid ref={refe} container size={{xs: 5, sm: 6, md: 6}}
                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 2, color: '#000'}}>
                {(totalRendimientos || totalBonos) ?
                    <Dona_Limpia ancho={ancho} labels={labels} series={[totalRendimientos, totalBonos]}
                                 marginTop={-10}/>

                    :
                    <AccessTime sx={{width: 100, height: 100, fill: '#ffffff20', pl: sCell ? 0 : 6}}/>
                }
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Ganancias

const labels = ['Rendimientos', 'Bonos']

const series = [1, 2]